import React, { Component } from 'react'
// import MainMicrosoftOfficeExcel2010 from './main_microsoft_office_excel_2010'
import { Helmet } from 'react-helmet'
import DictsInfo from '../../components/dicts_info.jsx'

// import { Link } from 'react-router-dom';
// import GambarPointer1 from './img/pointer1.png'

// function refreshPage(){
//     setTimeout(()=>{
//       window.location.reload(false);
//     }, 500);
   
//   }


export default class MengenalFungsiTanggalPadaMsOfficeExcel2010FungsiNow extends Component {
  render() {
    return (
      <div>

      <Helmet>
        <title>Mengenal Fungsi Tanggal Pada Microsoft Office Excel 2010</title>
        <meta name="description" content="belajar Microsoft Office Excel 2010, tutorial Microsoft Office Excel 2010, tutorial Microsoft Excel 2010 untuk pemula, berapa bagian Microsoft Excel"/>
      </Helmet>
      
        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">

              {/* <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInBottom"> */}
              <div className="col-md-9 col-md-offset-0 col-md-pull-0" >

              {/* <br/>
              <br/> */}
                  
                  
                <h1 style={{fontSize: '1.5rem'}} className="colorlib-heading">Mengenal Fungsi Tanggal Pada Microsoft Office Excel 2010</h1>

                <h2>Fungsi NOW</h2>

                <p>Apa fungsi NOW pada microsoft office excel 2010?</p>
                <p>Fungsi <b>NOW</b> pada microsoft office excel 2010 adalah untuk menampilkan data tanggal dan jam saat ini dari sistem komputer kita.</p>
                <p>Bentuk penulisannya adalah sebagai berikut:</p>
                <p><b>=NOW()</b></p>

                <p>Contoh:</p>
                <div className= "w3-container" > 
                    <div className= "w3-container" > 
                        <ul>                             
                           <li>Katakanlah saat ini adalah tanggal 13 Agustus 2010 jam 09:30:15. Maka apabila kita tuliskan fungsi <b>=NOW()</b> akan menghasilkan:
                           <br/>
                           <b>13/08/2010 09:30</b>
                           <br/>
                           Dan akan selalu di perbarui sesuai waktu nyata saat ini.</li>
                        </ul> 
                    </div>
                </div>

                <br/>
                <p><b>Semoga Bermanfaat..</b></p>
               
              </div>
              <DictsInfo/>
            </div>

            {/* <div className="row row-pt-md"></div> */}

          </div>
        </section>
        {/* <MainMicrosoftOfficeExcel2010/> */}
      </div>
    )
  }
}
